import React from "react";

import SiteWrapper from "../SiteWrapper";
import Column from "../Column";

import styles from "./styles.module.scss";

/**
 *
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 * @param {boolean} props.loading
 * @returns
 */
export default function Loading({ children, loading }) {
  return (
    <>
      {loading ? (
        <SiteWrapper size="small">
          <Column className={styles.content}>
            <div className={styles.loadingCtn}>
              <div className={styles.loading}></div>
            </div>
          </Column>
        </SiteWrapper>
      ) : (
        children
      )}
    </>
  );
}
